import * as React from 'react';
import { useLayoutEffect } from 'react';

export function useSafariRepaint<T extends HTMLElement | SVGElement>(
  ref: React.RefObject<T>,
  enabled: boolean
) {
  useLayoutEffect(() => {
    if (!enabled || !ref.current) return;
    const el = ref.current as HTMLElement;

    // create a fresh layer + force reflow + force paint, then clean up next frame
    const prev = {
      transform: el.style.transform,
      willChange: el.style.willChange,
      filter: (el.style as any).filter,
    };

    el.style.willChange = 'transform';
    el.style.transform = `${
      prev.transform ? prev.transform + ' ' : ''
    }translateZ(0)`;

    // force reflow (sync)
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    el.offsetHeight;

    // touch paint phase (no visual change)
    (el.style as any).filter = 'blur(0px)';

    const id = requestAnimationFrame(() => {
      (el.style as any).filter = prev.filter || '';
      el.style.transform = prev.transform || '';
      el.style.willChange = prev.willChange || '';
    });

    return () => cancelAnimationFrame(id);
  }, [enabled, ref]);
}
